// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__jeQKN","subheader":"ReorderModal_subheader__1lX1D","listWrap":"ReorderModal_listWrap__1IAzz"};